export function toCardFormat(num) {
    const str = num.toString();
    return str.replace(/(\d)(?=(\d{4})+(\D|$))/g, '$1 ')
}